// For making form submits w/ Turbo work. https://github.com/hotwired/turbo-ios/issues/125
export function submitForm(form) {
  form?.requestSubmit?.() || form?.submit?.()
}
